module.exports = __webpack_public_path__ + "static/media/icon-debit-credit-card.f668ba5a.png";